<template>
  <svg ref="svgRef" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="474" height="539" viewBox="0 0 474 539" fill="none">
    <defs>
      <mask id="mask" x="142.5" y="175" width="200" height="50" maskUnits="userSpaceOnUse">
        <g id="a">
          <path class="cls-6" d="M144,203.2c2.1,11.8,10.6,20.8,19.8,20.8s1.7-.1,2.4-.2c9.9-1.8,16.1-13.9,13.8-27-2.1-11.8-10.6-20.8-19.8-20.8s-1.6.1-2.4.2c-4.8.9-8.9,4.1-11.5,9.2s-3.4,11.4-2.3,17.8M318.8,223.8c.8.1,1.6.2,2.4.2,9.2,0,17.7-8.9,19.8-20.8,1.2-6.4.3-12.7-2.3-17.8s-6.7-8.4-11.5-9.2c-.8-.1-1.6-.2-2.4-.2-9.2,0-17.7,8.9-19.8,20.8-2.3,13.2,3.9,25.2,13.8,27"/>
        </g>
      </mask>
    </defs>
    <g id="_Слой_1" data-name="Слой_1">
      <g id="_Слой_28" data-name="Слой_28">
        <path class="cls-18" d="M451.6,312.2c61.4,88.7-10.7,174.1-159.7,213.2C226.6,546.9-10.6,563,.9,408.8c11.6-96.6,125.9-60.6,191.7-91.8,115.4-65.4,204.5-81.6,259-4.9h0Z"/>
      </g>
      <g id="_Слой_27" data-name="Слой_27">
        <path class="cls-15" d="M242.3,450.4c-11,0-20-9-20-20s9-20,20-20,20,9,20,20-9,20-20,20h0Z"/>
      </g>
      <g id="_Слой_26" data-name="Слой_26">
        <path class="cls-7" d="M348.3,309.1c-4.5-6.6-12.1-10.9-20.7-10.9-13.8,0-25,11.2-25,25s11.2,25,25,25,21.8-8.3,24.4-19.4c3.5-.6,6.9-1.5,10.2-2.7l-8.4-18.2c-1.8.5-3.6,1-5.5,1.2"/>
        <path class="cls-7" d="M395.7,299.4l-17-10.4c1.2-1.6,2.5-3.9,3.3-6l19.3,5.6c-1.7,5-5.6,10.8-5.6,10.8h0Z"/>
        <path class="cls-7" d="M384.1,277.3l19.2,5.6c1.1-3.9,1.9-7.9,2.3-12h-20.1c-.2,2.4-.7,4.5-1.4,6.4Z"/>
        <path class="cls-7" d="M405.4,255.9c.4,3,.7,6,.7,9h-20l-.5-6.4c-8.9-2.6-15.9-10-17.6-19.7-1-5.7,0-11.2,2.5-16l8.3,5.6c-1.1,2.6-1.6,5.6-1,8.6,1.4,8.2,9.2,13.6,17.4,12.2s13.6-9.2,12.2-17.4c-.5-3-1.9-5.7-3.9-7.7l6-8.1c4,3.6,6.8,8.5,7.8,14.1,1.9,10.5-3.1,20.6-11.8,25.8h0Z"/>
        <path class="cls-7" d="M359.4,305.8l8.4,18.1c3.8-1.7,7.3-3.8,10.7-6.1l-13.1-15.2c-2.1,1.2-4.1,2.3-6,3.2Z"/>
        <path class="cls-7" d="M370.2,298.9c2.7-2.3,2.9-2.5,5-5l17.2,10.5c-2.7,3.5-5.8,6.8-9.2,9.7l-13-15.2Z"/>
      </g>
      <g id="_Слой_29" data-name="Слой_29">
        <path class="cls-7" d="M113.8,298.9c-2.7-2.3-2.9-2.5-5-5l-17.2,10.5c2.7,3.5,5.8,6.8,9.2,9.7l13-15.2Z"/>
        <path class="cls-7" d="M135.7,309.1c4.5-6.6,12.1-10.9,20.7-10.9,13.8,0,25,11.2,25,25s-11.2,25-25,25-21.8-8.3-24.4-19.4c-3.5-.6-6.9-1.5-10.2-2.7l8.4-18.2c1.8.5,3.6,1,5.5,1.2h0Z"/>
        <path class="cls-7" d="M88.3,299.4l17-10.4c-1.2-1.6-2.5-3.9-3.3-6l-19.3,5.6c1.7,5,5.6,10.8,5.6,10.8h0Z"/>
        <path class="cls-7" d="M99.9,277.3l-19.2,5.6c-1.1-3.9-1.9-7.9-2.3-12h20.1c.2,2.4.7,4.5,1.4,6.4Z"/>
        <path class="cls-7" d="M78.6,255.9c-.4,3-.7,6-.7,9h20l.6-6.4c8.9-2.6,15.9-10,17.7-19.7,1-5.7,0-11.2-2.5-16l-8.3,5.6c1.1,2.6,1.6,5.6,1,8.6-1.4,8.2-9.2,13.6-17.4,12.2s-13.6-9.2-12.2-17.4c.5-3,1.9-5.7,3.9-7.7l-6-8.1c-4,3.6-6.8,8.5-7.8,14.1-1.8,10.5,3.1,20.6,11.8,25.8h0Z"/>
        <path class="cls-7" d="M124.6,305.8l-8.4,18.1c-3.8-1.7-7.3-3.8-10.7-6.1l13.1-15.2c2.1,1.2,4.1,2.3,6,3.2Z"/>
      </g>
      <g id="_Слой_25" data-name="Слой_25">
        <path
          fill="#fff"
          stroke="#222223"
          d="M242.322 281.314h-1.4c-21.726 0-43.786.055-60.419 5.512-8.304 2.725-15.214 6.784-20.05 12.821-4.831 6.03-7.631 14.082-7.631 24.867 0 21.804 11.463 49.475 28.435 71.709 16.983 22.248 39.354 38.891 61.065 38.891 21.712 0 44.082-16.643 61.065-38.891 16.972-22.234 28.435-49.905 28.435-71.709 0-10.785-2.793-18.837-7.617-24.868-4.828-6.036-11.729-10.095-20.026-12.82-16.621-5.457-38.681-5.512-60.457-5.512h-1.4Z"
        />
      </g>
      <g id="_Слой_24" data-name="Слой_24">
        <path class="cls-16" d="M242.5,281v154.7-154.7Z"/>
      </g>
      <g id="_Слой_23" data-name="Слой_23">
        <path class="cls-13" d="M264.3,346.1c0-12.1-9.9-22-22-22s-22,9.9-22,22,9.9,22,22,22,22-9.9,22-22Z"/>
      </g>
      <g id="_Слой_22" data-name="Слой_22">
        <path class="cls-4" d="M242.3,361.1c-8.3,0-15-6.7-15-15s6.7-15,15-15,15,6.7,15,15-6.7,15-15,15h0Z"/>
      </g>
      <g id="_Слой_21" data-name="Слой_21">
        <circle class="cls-15" cx="242.6" cy="103" r="5"/>
        <path class="cls-7" d="M240.6,111.2l-3,15h10l-3-15c-1.3.4-2.7.4-4,0Z"/>
      </g>
      <g id="_Слой_20" data-name="Слой_20">
        <path class="cls-13" d="M203.1,145c0-5.2,4.3-10.1,11.4-13.7,7.2-3.6,17.1-5.8,28.1-5.8s20.9,2.2,28.1,5.8c7.2,3.6,11.4,8.5,11.4,13.7s-4.3,10.1-11.4,13.7c-7.2,3.6-17.1,5.8-28.1,5.8s-20.9-2.2-28.1-5.8c-7.2-3.6-11.4-8.5-11.4-13.7Z"/>
      </g>
      <g id="_Слой_19" data-name="Слой_19">
        <path class="cls-6" d="M144,203.2c2,11.8,10.6,20.8,19.8,20.8s1.7-.1,2.4-.2c9.9-1.8,16.1-13.9,13.8-27-2.1-11.8-10.6-20.8-19.8-20.8s-1.6.1-2.4.2c-4.8.9-8.9,4.1-11.5,9.2s-3.4,11.4-2.3,17.8ZM318.8,223.8c.8.1,1.6.2,2.4.2,9.2,0,17.7-8.9,19.8-20.8,1.2-6.4.3-12.7-2.3-17.8s-6.7-8.4-11.5-9.2c-.8-.1-1.6-.2-2.4-.2-9.2,0-17.7,8.9-19.8,20.8-2.3,13.2,3.9,25.2,13.8,27Z"/>
      </g>
      <g id="_Слой_18" data-name="Слой_18">
        <g class="cls-1">
          <path class="cls-15" d="M144,203.2l-1,.2h0s1-.2,1-.2ZM166.2,223.8v1c.1,0,.2,0,.2,0h0s-.2-1-.2-1ZM180,196.8l1-.2h0s-1,.2-1,.2ZM157.8,176.2v-1h-.1v1ZM157.8,176.2v-1c-.1,0-.2,0-.2,0h0s.2,1,.2,1ZM146.3,185.4l-.9-.5.9.5ZM318.8,223.8l-.2,1h0s0,0,0,0v-1ZM341,203.2l-1-.2h0s1,.2,1,.2ZM338.7,185.4l-.9.5.9-.5ZM327.2,176.2l.2-1h0s0,0,0,0v1ZM327.2,176.2v-1c.1,0,.1,0,.1,0h0s-.1,1-.1,1ZM305,196.8l-1-.2h0s1,.2,1,.2ZM163.8,223c-8.5,0-16.8-8.4-18.8-20l-2,.4c2.2,12.1,10.9,21.6,20.8,21.6v-2ZM166.1,222.8c-.7,0-1.4.2-2.3.2v2c1,0,1.8-.1,2.5-.2l-.3-2ZM179,197c1.1,6.4.2,12.4-2.2,17.1s-6.2,7.9-10.8,8.7l.4,2c5.3-1,9.6-4.7,12.2-9.8s3.6-11.6,2.4-18.4l-2,.3ZM160.2,177c8.5,0,16.8,8.4,18.8,20l2-.4c-2.2-12.1-10.9-21.6-20.8-21.6v2ZM157.9,177.2c.8-.1,1.6-.2,2.3-.2v-2c-.9,0-1.7.1-2.5.2l.2,2ZM157.9,177.2l-.2-2,.2,2ZM147.2,185.9c2.5-4.9,6.3-7.8,10.8-8.7l-.4-2c-5.2,1-9.5,4.4-12.2,9.7l1.8.9ZM145,203c-1.1-6.2-.3-12.3,2.2-17.2l-1.8-.9c-2.7,5.3-3.5,11.8-2.4,18.4l2-.3ZM321.2,223c-.7,0-1.5,0-2.3-.2l-.2,2c.8,0,1.7.2,2.5.2v-2ZM340,203c-2.1,11.6-10.3,20-18.8,20v2c9.9,0,18.6-9.5,20.8-21.6l-2-.3ZM337.8,185.9c2.5,4.9,3.4,11,2.2,17.2l2,.4c1.2-6.6.3-13.1-2.4-18.4l-1.8.9ZM327,177.2c4.4.7,8.3,3.8,10.8,8.7l1.8-.9c-2.7-5.3-7.1-8.9-12.2-9.7l-.3,2ZM327,177.2l.3-2-.3,2ZM324.8,177c.7,0,1.5,0,2.3.2l.2-2c-.8,0-1.7-.2-2.5-.2v2ZM305.9,197c2.1-11.6,10.3-20,18.8-20v-2c-9.9,0-18.6,9.5-20.8,21.6l2,.3ZM318.9,222.8c-4.6-.8-8.4-4-10.8-8.7-2.4-4.7-3.3-10.7-2.2-17.1l-2-.3c-1.2,6.8-.2,13.3,2.4,18.4,2.6,5.1,6.9,8.8,12.2,9.8l.4-2Z"/>
        </g>
      </g>
      <g id="_Слой_17" data-name="Слой_17">
        <path class="cls-13" d="M157.7,197.8c0-20.6,10.8-35.5,26.9-45.4,16.1-9.8,37.3-14.5,58-14.5s42,4.7,58,14.5c16,9.8,26.9,24.8,26.9,45.4s-10.9,39.3-26.9,52.9c-16.1,13.6-37.3,22-58,22s-41.9-8.4-58-22-26.9-32.3-26.9-52.9h0Z"/>
      </g>
      <g id="_Слой_16" data-name="Слой_16">
        <path class="cls-15" d="M310.5,208.5c0,33.1-34.8,60-67.9,60s-67.9-26.8-67.9-60,34.8-48,67.9-48,67.9,14.9,67.9,48Z"/>
      </g>
      <g id="_Слой_15" data-name="Слой_15">
        <path id="eye-left" class="cls-5" d="M210.652 208c-4.282 0-7.5 3.27-7.5 7a3 3 0 1 1-6 0c0-7.316 6.184-13 13.5-13s13.5 5.684 13.5 13a3 3 0 1 1-6 0c0-3.73-3.218-7-7.5-7" />
        <path id="eye-right" class="cls-5" d="M273.652 208c-4.282 0-7.5 3.27-7.5 7a3 3 0 1 1-6 0c0-7.316 6.184-13 13.5-13s13.5 5.684 13.5 13a3 3 0 1 1-6 0c0-3.73-3.218-7-7.5-7" />
      </g>
    </g>

    <g id="portals-back">
      <g id="portal-right-back">
        <ellipse cx="396" cy="185" rx="45" ry="10" fill="#000" />
        <path d="M 351 185 A 45 10 0 0 0 441 185" fill="none" stroke="#F4CB19" stroke-width="3" style="filter: drop-shadow(0 0 15px #F4CB19)"/>
      </g>

      <g id="portal-left-back">
        <ellipse cx="87" cy="185" rx="45" ry="10" fill="#000" />
        <path d="M 42 185 A 45 10 0 0 0 132 185" fill="none" stroke="#94BAFA" stroke-width="3" style="filter: drop-shadow(0 0 15px #94BAFA)" />
      </g>
    </g>
    <g class="icons-layer" transform="translate(0, -4)">
      <path
        id="iconsMotionPath"
        d="M396.367 205.740
          C395.681 197.311 396.595 179.179 396.429 165.894
          C396.119 141.211 387.206 115.370 369.982  93.676
          C357.799  78.331 358.030  74.016 334.299  57.402
          C319.452  47.007 307.092  43.279 287.481  39.412
          C251.654  32.363 211.645  35.485 198.384  39.251
          C183.452  43.500 178.388  47.935 154.719  59.540
          C138.911  67.237 131.784  77.364 118.242  91.508
          C104.212 106.154 103.811 107.261  96.150 127.004
          C 87.300 149.817  89.073 147.633  87.403 166.246
          C 86.512 176.257  86.184 193.788  86.821 206.038"
        fill="none"
        stroke="none"
      />
        <g id="blueIcon">
        <g id="_Слой_14" data-name="Слой_14">
          <path class="cls-12" d="M105.5,160.7c2.7,10.1-3.3,20.6-13.4,23.3s-20.6-3.3-23.3-13.4,3.3-20.6,13.4-23.3,20.6,3.3,23.3,13.4M104.1,164.7c.4,7.9-4.7,15.2-12.6,17.3-7.9,2.1-16-1.7-19.6-8.7l11.3-3,1.1-2.9,9.3,10.8,2.3-11.3,8.2-2.2ZM103.9,162.7l-9.7,2.6-1.7,8.5-8.8-10.3-1.9,5.1-10.5,2.8c-.3-.8-.5-1.6-.7-2.4l9.3-2.5,1.7-8.5,8.8,10.3,1.9-5.1,11.1-3c.3.8.5,1.6.6,2.4M82.7,149.2c-8.1,2.2-13.2,9.8-12.5,17.9l7.8-2.1,2.3-11.3,9.3,10.8,1.1-2.9,11.8-3.2c-3.4-7.3-11.7-11.4-19.8-9.2"/>
        </g>
        <g id="_Слой_13" data-name="Слой_13">
          <path class="cls-12" d="M57,149.9c-.3-1.1.3-2.2,1.4-2.4,0,0,0,0,0,0l44.4-11.9c1.1-.3,2.2.3,2.4,1.4,0,0,0,0,0,0l11.9,44.4c.3,1.1-.3,2.2-1.4,2.4,0,0,0,0,0,0l-44.4,11.9c-1.1.3-2.2-.3-2.4-1.4,0,0,0,0,0,0l-11.9-44.4ZM58.9,149.4l44.4-11.9,11.9,44.4-44.4,11.9-11.9-44.4Z"/>
        </g>
      </g>
      <g id="redIcon">
        <g id="_Слой_12" data-name="Слой_12">
          <path class="cls-8" d="M128.8,106.9l2.9.8c1.1.3,2.2-.3,2.4-1.4,0,0,0,0,0,0l4.7-17.4c.3-1.1-.3-2.2-1.4-2.4,0,0,0,0,0,0l-2.9-.8,1-3.9c.1-.5-.2-1.1-.7-1.2-.5-.1-1.1.2-1.2.7l-1,3.9-5.8-1.6,1-3.9c.2-.5-.1-1.1-.7-1.2-.5-.2-1.1.1-1.2.7,0,0,0,0,0,0l-1,3.9-7.7-2.1,1-3.9c.1-.5-.2-1.1-.7-1.2-.5-.1-1.1.2-1.2.7,0,0,0,0,0,0l-1,3.9-5.8-1.6,1-3.9c.1-.5-.2-1.1-.7-1.2s-1.1.2-1.2.7l-1,3.9-2.9-.8c-1.1-.3-2.2.3-2.4,1.4,0,0,0,0,0,0l-4.7,17.4c-.3,1.1.3,2.2,1.4,2.4,0,0,0,0,0,0l2.9.8-1,3.9c-.1.5.2,1.1.7,1.2s1.1-.2,1.2-.7l1-3.9,5.8,1.6-1,3.9c-.1.5.2,1.1.7,1.2.5.1,1.1-.2,1.2-.7l1-3.9,7.7,2.1-1,3.9c-.1.5.2,1.1.7,1.2.5.1,1.1-.2,1.2-.7l1-3.9,5.8,1.6-1,3.9c-.1.5.2,1.1.7,1.2s1.1-.2,1.2-.7l1-3.9ZM136.9,88.3l-3.6-1s0,0-.1,0l-7.2,2.9-2.2,8.2,4.8,6.1s0,0,0,.1l3.6,1,4.7-17.4ZM112.5,100.4l6.5,1.8-.9-4.4-2.7-.7-3,3.3ZM115.4,95l-2.9-.8h0s1.6-5.8,1.6-5.8h0s2.9.8,2.9.8h0s3.8,1,3.8,1h0s2.9.8,2.9.8h0s-1.6,5.8-1.6,5.8h0s-2.9-.8-2.9-.8h0s-3.8-1-3.8-1h0ZM113.3,96.5l-3,3.3-4.2-1.1,6.2-2.5,1,.3ZM110.8,81.3l4.2,1.1.9,4.4-1-.3-4.1-5.2ZM117.2,83l.9,4.4,2.7.7,3-3.3-6.5-1.8ZM121.2,102.8l4.2,1.1-4.1-5.2-1-.3.9,4.4ZM125.9,85.4l-3,3.3,1,.3,6.2-2.5-4.2-1.1ZM102.9,97.9l-3.6-1,4.7-17.4,3.6,1s0,0,0,.1l4.8,6.1-2.2,8.2-7.2,2.9s0,0-.1,0"/>
        </g>
        <g id="_Слой_11" data-name="Слой_11">
          <path class="cls-8" d="M87.9,109l12.2-45.7c.2-.7.9-1.2,1.7-1l45.7,12.2c.7.2,1.2.9,1,1.7l-12.2,45.7c-.2.7-.9,1.2-1.7,1l-45.7-12.2c-.7-.3-1.2-.9-1-1.7M134.4,120.8l11.9-44.4-44.4-11.9-11.9,44.4,44.4,11.9Z"/>
        </g>
      </g>
      <g id="greenIcon">
        <g id="_Слой_10" data-name="Слой_10">
          <path class="cls-14" d="M192.9,21.3c.5-.1,1.1.2,1.2.7,0,0,0,0,0,0l1.6,5.8c2.3-.5,4.7-.3,7,.3,2.6.8,5,2.2,6.8,4.2,1.9,2,3.2,4.4,3.8,7.1.6,2.7.5,5.4-.3,8.1-.1.5-.7.8-1.2.7s-.8-.7-.7-1.2c0,0,0,0,0,0,.7-2.3.8-4.7.2-7-.5-2.3-1.7-4.5-3.3-6.2-1.6-1.7-3.7-3-5.9-3.6-1.9-.6-3.9-.7-5.9-.3l3.1,11.6,3.4-.9c.5-.1,1.1.2,1.2.7.1.5-.2,1.1-.7,1.2l-3.4.9.2.6,15.6,9c.5.3.6.9.4,1.4-.3.5-.9.6-1.4.4l-15.1-8.7-8.7,15.1c-.3.5-.9.6-1.4.4s-.6-.9-.4-1.4l9-15.6-.2-.6-3.4.9c-.5.1-1.1-.2-1.2-.7s.2-1.1.7-1.2c0,0,0,0,0,0l3.4-.9-3.1-11.6c-1.9.7-3.6,1.8-5,3.2-1.6,1.7-2.8,3.8-3.3,6.1-.5,2.3-.5,4.7.2,7,.7,2.3,2,4.3,3.7,6,.4.4.4,1,0,1.4s-1,.4-1.4,0c0,0,0,0,0,0-2-1.9-3.5-4.2-4.3-6.8-.8-2.6-.9-5.4-.3-8.1.6-2.6,1.9-5.1,3.8-7,1.6-1.7,3.6-3,5.9-3.8l-1.6-5.8c-.1-.5.2-1.1.7-1.2,0,0,0,0,0,0h0Z"/>
        </g>
        <g id="_Слой_9" data-name="Слой_9">
          <path class="cls-10" d="M169.4,22.4c-1.1.3-1.7,1.4-1.4,2.4,0,0,0,0,0,0l11.9,44.4c.3,1.1,1.4,1.7,2.4,1.4,0,0,0,0,0,0l44.4-11.9c1.1-.3,1.7-1.4,1.4-2.4,0,0,0,0,0,0l-11.9-44.4c-.3-1.1-1.4-1.7-2.4-1.4,0,0,0,0,0,0l-44.4,11.9ZM214.4,12.5l-44.4,11.9,11.9,44.4,44.4-11.9-11.9-44.4Z"/>
        </g>
      </g>
      <g id="yellowIcon">
        <g id="_Слой_4" data-name="Слой_4">
          <path class="cls-17" d="M286.3,43.5c1.6.4,3.3-.5,3.7-2.1.4-1.6-.5-3.3-2.1-3.7,0,0,0,0,0,0-1.6-.4-3.2.6-3.6,2.2-.4,1.6.5,3.2,2.1,3.6Z"/>
        </g>
        <g id="_Слой_3" data-name="Слой_3">
          <path class="cls-11" d="M299.5,23.2c1.3.2,1.7,1.8.7,2.6l-2.7,2c4.3,4.3,6.9,8.9,7.1,13.8.3,5.1-1.9,10.2-6.8,15.5-.3.3-.7.5-1.1.5-.4,0-.7-.2-1-.3-.5-.4-.9-1.1-.4-1.9,1.9-3.5,2.7-7,2-10.7-.7-3.6-2.8-7.5-7.1-11.7l-3.2,2.6c-.9.8-2.4.2-2.5-1l-.8-12.2c0-.9.8-1.7,1.7-1.5l14,2.4ZM298.1,25l-12.2-2.1.7,10.6,2.8-2.3c.6-.5,1.4-.4,2,0,4.8,4.5,7.3,8.8,8.1,13.1.6,3.2.2,6.2-.9,9,3.1-4.1,4.4-8,4.2-11.7-.2-4.4-2.6-8.7-6.9-13-.6-.6-.6-1.7.1-2.2l2.2-1.6ZM274,55.4c-1,.8-.6,2.4.7,2.6l14,2.4c.9.2,1.8-.6,1.7-1.5l-.8-12.2c0-1.2-1.5-1.8-2.5-1l-3.2,2.6c-4.3-4.2-6.5-8.1-7.1-11.7-.7-3.7.2-7.3,2-10.7.4-.8,0-1.5-.4-1.9-.3-.2-.6-.3-1-.4-.4,0-.8.2-1.1.5-4.9,5.3-7,10.5-6.8,15.5.3,4.9,2.8,9.5,7.1,13.8l-2.7,2ZM288.4,58.4l-12.2-2.1,2.2-1.6c.7-.5.8-1.6.1-2.2-4.3-4.2-6.7-8.5-6.9-13-.2-3.7,1.1-7.5,4.2-11.7-1.1,2.9-1.5,5.9-.9,9,.8,4.2,3.3,8.6,8.1,13.1.5.5,1.4.6,2,0l2.8-2.3.7,10.6Z"/>
        </g>
        <g id="_Слой_2" data-name="Слой_2">
          <path class="cls-11" d="M268.9,11.9c.3-1.1,1.4-1.7,2.4-1.4,0,0,0,0,0,0l44.4,11.9c1.1.3,1.7,1.4,1.4,2.4,0,0,0,0,0,0l-11.9,44.4c-.3,1.1-1.4,1.7-2.4,1.4,0,0,0,0,0,0l-44.4-11.9c-1.1-.3-1.7-1.4-1.4-2.4,0,0,0,0,0,0l11.9-44.4ZM270.9,12.4l44.4,11.9-11.9,44.4-44.4-11.9,11.9-44.4Z"/>
        </g>
      </g>
      <g id="orangeIcon">
        <g id="_Слой_8" data-name="Слой_8">
          <path class="cls-2" d="M361.5,104.5c.2.7-.2,1.4-.9,1.5-.7.2-1.4-.2-1.5-.9s.2-1.4.9-1.5c.7-.2,1.4.2,1.5.9M363.7,102.1c.7-.2,1.1-.8.9-1.5-.2-.7-.8-1.1-1.5-.9,0,0,0,0,0,0-.7.2-1,.9-.8,1.6.2.6.8,1,1.5.9M366.4,103.2c.2.7-.2,1.4-.9,1.5s-1.4-.2-1.5-.9.2-1.4.9-1.5,1.4.2,1.5.9h0M368.6,100.8c.7-.2,1.1-.9.9-1.5-.2-.7-.9-1.1-1.5-.9-.7.2-1.1.8-.9,1.5s.8,1.1,1.5.9c0,0,0,0,0,0M371.2,101.9c.2.7-.2,1.4-.8,1.6-.7.2-1.4-.2-1.6-.8,0,0,0,0,0,0-.2-.7.3-1.3.9-1.5.6-.1,1.3.2,1.5.9M373.4,99.5c.7-.2,1.1-.9.9-1.5-.2-.7-.9-1.1-1.5-.9-.7.2-1.1.9-.9,1.5.2.7.9,1.1,1.5.9"/>
        </g>
        <g id="_Слой_7" data-name="Слой_7">
          <path class="cls-3" d="M355.5,80c-.5.1-.9.7-.7,1.2,0,0,0,0,0,0l4.7,17.4c0,0,0,.1,0,.2l-8.8,10.7c-.9,1.1.1,2.8,1.5,2.4l20.5-5.5s0,0,0,0c.2,0,.4-.1.5-.3l12.7-13.1c.5-.5.6-1.2.3-1.7l-8.5-16.5h0s0,0,0,0c-.2-.4-.7-.6-1.1-.5l-21.2,5.7ZM361.1,97.1l-4.1-15.5,19.3-5.2,4.1,15.5-19.3,5.2ZM382.6,92.4c0,0,0,0,0,.1.2.3.2.7.1,1l1.6-1.7-4-7.9,2.2,8.3ZM361.9,99l18.1-4.8-8,10.4-18.9,5.1,8.7-10.6Z"/>
        </g>
        <g id="_Слой_6" data-name="Слой_6">
          <path class="cls-3" d="M336,76.9c-.3-1.1.3-2.2,1.4-2.4,0,0,0,0,0,0l44.4-11.9c1.1-.3,2.2.3,2.4,1.4,0,0,0,0,0,0l11.9,44.4c.3,1.1-.3,2.2-1.4,2.4,0,0,0,0,0,0l-44.4,11.9c-1.1.3-2.2-.3-2.4-1.4,0,0,0,0,0,0l-11.9-44.4ZM337.9,76.4l44.4-11.9,11.9,44.4-44.4,11.9-11.9-44.4Z"/>
        </g>
      </g>
      <g id="purpleIcon" data-name="Слой_5">
        <path class="cls-9" d="M425.3,149.4l-44.4-11.9-11.9,44.4,44.4,11.9,11.9-44.4ZM381.4,135.5c-1.1-.3-2.2.3-2.4,1.4,0,0,0,0,0,0l-11.9,44.4c-.3,1.1.3,2.2,1.4,2.4,0,0,0,0,0,0l44.4,11.9c1.1.3,2.2-.3,2.4-1.4,0,0,0,0,0,0l11.9-44.4c.3-1.1-.3-2.2-1.4-2.4,0,0,0,0,0,0l-44.4-11.9ZM385,178.9c-.6,2.1-2.7,3.4-4.9,2.9-2.1-.6-3.4-2.7-2.9-4.9,0,0,0,0,0,0,.4-1.6,1.7-2.7,3.3-2.9-1.1-2-1.6-3.8-1.6-5.4,0-1.8.7-3.4,1.8-4.7h0c.3.6.6,1.3.9,1.9-.5.8-.8,1.8-.8,2.7,0,1.3.6,3.8,2.1,5.8,0,0,0,.1,0,.2,1.5.9,2.3,2.7,1.8,4.5M392.7,185.1c2.1.6,4.3-.7,4.9-2.8.4-1.6-.1-3.2-1.4-4.2,0,0,0-.1-.2-.2-5.2-5.4-8.7-9.6-10.6-13-2-3.4-2.2-5.7-1.5-7.5.2-.5.5-.9.8-1.3-.4-.6-.7-1.2-1-1.8-.7.7-1.3,1.5-1.6,2.3-1.2,2.6-.5,5.7,1.6,9.3,1.8,3.2,4.9,6.9,9.1,11.5-2.1.5-3.5,2.7-2.9,4.8.3,1.4,1.4,2.5,2.9,2.9M410.1,185.7c-.6,2.1-2.8,3.4-4.9,2.8-2.1-.6-3.4-2.8-2.8-4.9.4-1.7,1.9-2.9,3.7-3-.7-2.5-2.6-5.3-5.2-8.3-1.5-1.8-3.1-3.5-4.8-5.3l-.7-.7c-1.5-1.6-2.9-3.1-4.3-4.7-3.1-3.5-5.9-7.1-6.6-10.4-.4-1.7-.3-3.4.6-5,.8-1.6,2.4-2.9,4.6-4,.5-.2,1.1,0,1.3.5.2.5,0,1-.4,1.3-2,1-3.2,2.1-3.7,3.2-.6,1.1-.7,2.3-.4,3.6.7,2.8,3,6,6.2,9.6,1.3,1.5,2.8,3.1,4.3,4.6l.7.7c1.7,1.8,3.4,3.6,4.9,5.4,2.8,3.4,5.2,6.8,5.8,10.1,1.6.9,2.4,2.8,1.9,4.5M390.5,152.5c-.6.2-1.2.5-1.7.8-.3-.6-.6-1.2-.9-1.8.6-.3,1.2-.6,1.8-.8,3.8-1.6,9-3,15.3-4.5.5-.1,1.1.2,1.2.7.1.5-.2,1.1-.7,1.2-6.3,1.5-11.3,2.9-15,4.4M387.1,159.7c-.7.3-1.3.6-2,.9.1.6.3,1.2.7,1.9.9-.4,1.7-.8,2.6-1.2-.4-.5-.9-1.1-1.3-1.6M393.6,159.6c2.1-.6,4.3-1.2,6.5-1.7,1.9-.5,3.9-1,5.8-1.5,4.7-1.3,9.2-2.9,12.5-5.1.5-.3.6-.9.2-1.4-.3-.5-.9-.6-1.4-.2-2.9,2-7.1,3.5-11.8,4.8-1.8.5-3.7,1-5.7,1.5-2.6.7-5.2,1.3-7.5,2,.4.5.9,1.1,1.4,1.7"/>
      </g>
    </g>

    <g id="portals-front">
      <g id="portal-right-front">
        <path d="M 441 185 A 45 10 0 0 1 351 185 L 351 200 A 45 15 0 0 0 441 200 Z" fill="#fff"/>
        <path d="M 441 185 A 45 10 0 0 1 351 185" fill="none" stroke="#F4CB19" stroke-width="3" stroke-linecap="round" style="filter: drop-shadow(0 0 10px #F4CB19)" />
      </g>
      <g id="portal-left-front">
        <path d="M 132 185 A 45 10 0 0 1 42 185 L 42 200 A 45 15 0 0 0 132 200 Z" fill="#fff" />
        <path d="M 132 185 A 45 10 0 0 1 42 185" fill="none" stroke="#94BAFA" stroke-width="3" stroke-linecap="round" style="filter: drop-shadow(0 0 10px #94BAFA)" />
      </g>
    </g>
  </svg>
</template>

<script setup>
import { onMounted, onUnmounted, ref } from 'vue'
import { gsap } from 'gsap'
import { MotionPathPlugin } from "gsap/MotionPathPlugin"
gsap.registerPlugin(MotionPathPlugin)

defineProps({
  buttonStates: {
    type: Array,
    default: () => [false, false, false]
  }
})

const svgRef = ref(null)
const eyes = '#eye-left, #eye-right'
const portalState = { leftBusy: false, rightBusy: false }
const isMobile = window.matchMedia('(max-width: 768px)')

const initRobot = () => {
  initBlink()
  initPortals()
  initIconAnimation()
  initFloat()
}

const initFloat = () => {
  gsap.to(svgRef.value, {
    y: -8,
    duration: 2.5,
    ease: 'sine.inOut',
    yoyo: true,
    repeat: -1,
  })
}

// Оба портала по умолчанию чуть сжаты, открываются когда иконка подходит
const initPortals = () => {
  gsap.set('#portal-right-back, #portal-right-front', { scaleX: 0.8, svgOrigin: '396 185' })
  gsap.set('#portal-left-back, #portal-left-front',   { scaleX: 0.8, svgOrigin: '87 185' })
}

const animatePortal = (side) => {
  const selector = side === 'right'
    ? '#portal-right-back, #portal-right-front'
    : '#portal-left-back, #portal-left-front'
  const cx  = side === 'right' ? '396 185' : '87 185'
  const key = side + 'Busy'

  if (portalState[key]) return
  portalState[key] = true

  gsap.timeline({ onComplete: () => { portalState[key] = false } })
    .to(selector, { scaleX: 1,   duration: 0.4, svgOrigin: cx, ease: 'sine.out' })
    .to(selector, { scaleX: 0.8, duration: 0.4, svgOrigin: cx, ease: 'sine.inOut', delay: 0.8 })
}

const initIconAnimation = () => {
  const icons = [
    '#purpleIcon',
    '#orangeIcon',
    '#yellowIcon',
    '#greenIcon',
    '#redIcon',
    '#blueIcon',
  ]
  const total = icons.length
  icons.forEach((selector, i) => {
    animateIcon(selector, i / total, i / total + 1)
  })
}

const getScaleAtProgress = (localProg) => {
  const FADE_OUT_START = 0.95
  const FADE_OUT_END = 0.98
  const FADE_IN_START = 0.02
  const FADE_IN_END = 0.05

  if (localProg >= FADE_OUT_START && localProg <= FADE_OUT_END) {
    const t = (localProg - FADE_OUT_START) / (FADE_OUT_END - FADE_OUT_START)
    const eased = gsap.parseEase("power2.in")(t)
    return 1 - eased * 0.7
  }

  if (localProg > FADE_OUT_END) return 0
  if (localProg <= FADE_IN_START) return 0

  if (localProg <= FADE_IN_END) {
    const t = (localProg - FADE_IN_START) / (FADE_IN_END - FADE_IN_START)
    const eased = gsap.parseEase("power2.out")(t)
    return eased * 1.0
  }

  return 1
}

const animateIcon = (selector, start, end) => {
  const tl = gsap.timeline({ repeat: -1 })
  const tween = tl.to(selector, {
    duration: 19,
    ease: "none",
    motionPath: {
      path: "#iconsMotionPath",
      align: "#iconsMotionPath",
      alignOrigin: [0.5, 0.5],
      start,
      end
    },
    onUpdate: () => {
      const progress = tween.progress()
      const absolute = start + progress * (end - start)
      const local = absolute - Math.floor(absolute)

      gsap.set(selector, { scale: getScaleAtProgress(local) })

      // Жёлтый открывается чуть до выхода иконки, синий когда иконка подходит
      if (local >= 0.005 && local <= 0.015) animatePortal('right')
      if (local >= 0.91  && local <= 0.94)  animatePortal('left')
    }
  })

  return tl
}

const initBlink = () => {
  gsap.timeline({ repeat: -1, repeatDelay: 3 })
    .to(eyes, { scaleY: 0.1, duration: 0.08, transformOrigin: '50% 50%' })
    .to(eyes, { scaleY: 1,   duration: 0.08, transformOrigin: '50% 50%' })
}

const lookAtButton = (buttonIndex) => {
  if (isMobile.matches) {
    if (buttonIndex == 1) gsap.to(eyes, { x: 0, y: -12, duration: 0.3, ease: 'power2.out' })
    if (buttonIndex == 2) gsap.to(eyes, { x: 0, y: -8,  duration: 0.3, ease: 'power2.out' })
    if (buttonIndex == 3) gsap.to(eyes, { x: 0, y: -4,  duration: 0.3, ease: 'power2.out' })
  } else {
    if (buttonIndex == 1) gsap.to(eyes, { x: -5, y: -5, duration: 0.3, ease: 'power2.out' })
    if (buttonIndex == 2) gsap.to(eyes, { x: -8, y: 0,  duration: 0.3, ease: 'power2.out' })
    if (buttonIndex == 3) gsap.to(eyes, { x: -5, y: 5,  duration: 0.3, ease: 'power2.out' })
  }
}

const resetEyes = () => {
  gsap.to(eyes, { x: 0, y: 0, duration: 0.3, ease: 'power2.out' })
}

onMounted(() => { initRobot() })
onUnmounted(() => { gsap.globalTimeline.clear() })

defineExpose({
  lookAtButton,
  resetEyes,
})
</script>

<style lang="scss" scoped>
  .cls-1 { mask: url(#mask); }
  .cls-2, .cls-3 { fill: #f37029; }
  .cls-4, .cls-5 { fill: #36cce8; }
  .cls-6, .cls-5, .cls-7, .cls-8, .cls-9, .cls-3, .cls-10, .cls-11, .cls-12 { fill-rule: evenodd; }
  .cls-6, .cls-13 { fill: #fff; }
  .cls-14, .cls-10 { fill: #00a14b; }
  .cls-7, .cls-15 { fill: #222223; }
  .cls-8 { fill: #ed1c24; }
  .cls-16 { fill: none; stroke-miterlimit: 10; }
  .cls-16, .cls-13 { stroke: #222223; }
  .cls-17, .cls-11 { fill: #ffc20e; }
  .cls-9 { fill: #98258f; }
  .cls-12 { fill: #2b3990; }
  .cls-18 { fill: #eeecf4; }
</style>